import { render, staticRenderFns } from "./standingBook.vue?vue&type=template&id=01b7189b"
import script from "./standingBook.vue?vue&type=script&lang=js"
export * from "./standingBook.vue?vue&type=script&lang=js"
import style0 from "./standingBook.vue?vue&type=style&index=0&id=01b7189b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports